import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => { e.preventDefault(); setLoading(true);
    try { const { data } = await api.post("/auth/forgot-password", { email });
      setLink(data.reset_link || "Check your email (or backend logs) for a reset link."); }
    finally { setLoading(false); } };
  return (
    <div className="paper-grain min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="forgot-page">
      <form onSubmit={submit} className="paper-card p-10 w-full max-w-md">
        <h1 className="font-serif-display text-3xl mb-2">Forgot password</h1>
        <p className="text-sm text-[#5C5C5C] mb-4">We'll send a reset link to your email.</p>
        <input className="mp-input mb-4" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email"/>
        <button className="btn-primary w-full" disabled={loading} data-testid="forgot-submit">{loading ? "..." : "Send reset link"}</button>
        {link && <div className="mt-4 text-sm bg-[#F0EBE1] p-3 break-all" data-testid="forgot-link">{link.startsWith("http") ? <a href={link} className="underline text-[#8C3A3A]">{link}</a> : link}</div>}
        <p className="text-sm mt-4"><Link to="/login" className="underline text-[#8C3A3A]">← back to login</Link></p>
      </form>
    </div>
  );
}

export function ResetPassword() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState(""); const [err, setErr] = useState(""); const [ok, setOk] = useState(false);
  const submit = async (e) => { e.preventDefault(); setErr("");
    try { await api.post("/auth/reset-password", { code, password: pw }); setOk(true); setTimeout(() => navigate("/login"), 1500); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail) || "Failed"); } };
  return (
    <div className="paper-grain min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="reset-page">
      <form onSubmit={submit} className="paper-card p-10 w-full max-w-md">
        <h1 className="font-serif-display text-3xl mb-4">Set a new password</h1>
        <input className="mp-input mb-4" type="password" minLength={6} placeholder="New password (min 6)" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-password-input"/>
        {err && <p className="text-sm text-[#8C3A3A] mb-2">{err}</p>}
        {ok && <p className="text-sm text-[#3A5A40] mb-2">Password updated. Redirecting to login…</p>}
        <button className="btn-primary w-full" data-testid="reset-submit-btn">Update password</button>
      </form>
    </div>
  );
}
